import { useTranslation } from 'react-i18next';

// ─── Status badge configs ─────────────────────────────────
const BORD_STATUS_CFG = {
  ready:        { labelKey: 'screens.riskCarriers.bordStatusReady',        defaultLabel: 'Ready',        bg: '#dcfce7', color: '#15803d' },
  sent:         { labelKey: 'screens.riskCarriers.bordStatusSent',         defaultLabel: 'Sent',         bg: '#dbeafe', color: '#1d4ed8' },
  generating:   { labelKey: 'screens.riskCarriers.bordStatusGenerating',   defaultLabel: 'Generating',   bg: '#ede9fe', color: '#7c3aed' },
  acknowledged: { labelKey: 'screens.riskCarriers.bordStatusAcknowledged', defaultLabel: 'Acknowledged', bg: '#f1f5f9', color: '#64748b' },
  error:        { labelKey: 'screens.riskCarriers.bordStatusError',        defaultLabel: 'Error',        bg: '#fee2e2', color: '#991b1b' },
};

const BordBadge = ({ status }) => {
  const { t } = useTranslation();
  const cfg = BORD_STATUS_CFG[status] || BORD_STATUS_CFG.generating;
  return <span style={{ padding: '3px 10px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: cfg.bg, color: cfg.color }}>{t(cfg.labelKey, { defaultValue: cfg.defaultLabel })}</span>;
};

export default BordBadge;
